export function CtaSection() {
  return (
    <section className="cta-section shell" id="pricing">
      <div className="cta-flight-path">&#8961;</div>
      <div className="cta-content fade-up">
        <span className="kicker">READY WHEN YOU ARE</span>
        <h2>
          Your next idea is
          <br />
          ready to <em>land.</em>
        </h2>
        <p>Start free. No credit card required.</p>
        <a className="btn-dark-landing" href="/register">
          Bring your idea to life &#8599;
        </a>
      </div>
      <svg className="cta-kite-icon" viewBox="0 0 48 48">
        <path fill="#fff" d="M24 3 43 22 24 31 5 22 24 3Zm0 29 8 5-8 8-8-8 8-5Z" />
      </svg>
    </section>
  );
}
